import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { useRouteMatch } from "react-router";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { compose } from "recompose";
import { searchUserRelatedServiceProviders } from "~redux/modules/user";

const RelatedServiceProviderFilter = ({
  intl,
  searchUserRelatedServiceProviders,
}) => {
  const match = useRouteMatch();

  const f = [
    {
      id: 1,
      label: intl.formatMessage({
        id: "app.userProfile.relatedServiceProviders.filter.allProviders",
      }),
    },
    {
      id: 2,
      label: intl.formatMessage({
        id: "app.userProfile.relatedServiceProviders.filter.administeredProviders",
      }),
    },
    {
      id: 3,
      label: intl.formatMessage({
        id: "app.userProfile.relatedServiceProviders.filter.archievedProviders",
      }),
    },
    {
      id: 4,
      label: intl.formatMessage({
        id: "app.userProfile.relatedServiceProviders.filter.removedProviders",
      }),
    },
  ];
  const [filter, setCurrentFilter] = useState(1);

  useEffect(() => {
    if (!!match.params.userId) {
      searchUserRelatedServiceProviders(match.params.userId, filter);
    }
  }, [filter]);

  const onChangeFilter = (event) => {
    setCurrentFilter(event.target.value);
  };

  return (
    <FormControl
      style={{
        textAlign: "center",
        width: "100%",
        overflow: "hidden",
        minHeight: "48px",
      }}
    >
      <Select
        value={filter}
        onChange={onChangeFilter}
        autoWidth
        displayEmpty={true}
        style={{
          color: "white",
          fontSize: "20px",
          lineHeight: "1",
          letterSpacing: "0.25px",
          fontWeight: "700",
          padding: "0 0 0 24px",
          minHeight: "48px",
        }}
      >
        {f.map((filter) => (
          <MenuItem value={filter.id} id={filter.id} key={filter.id}>
            {filter.label}{" "}
            <KeyboardArrowDownIcon
              style={{
                color: "white",
                fontSize: "22px",
                margin: "0 0 -5px 5px",
              }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  searchUserRelatedServiceProviders: (
    userId,
    userRelatedServiceProviderFilter,
  ) => {
    return dispatch(
      searchUserRelatedServiceProviders(
        userId,
        userRelatedServiceProviderFilter,
      ),
    );
  },
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
);
export default enhance(RelatedServiceProviderFilter);
